import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import moment from "moment";
import { toast } from "react-toastify";
import "./orderdetail.css"

function OrderDetail(props) {
    const navigate = useNavigate()
    const [orderdetail, setOrderDetail] = useState([])
    const [lgShow1, setLgShow1] = useState(false);
    const [ordertotal, setOrderTotal] = useState(0)
    const [ordersubtotal, setOrderSubTotal] = useState(0)
  
   
   
    function Logout() {
        setLgShow1(true)

    }
    function Logoutmain() {
        window.localStorage.setItem('LoggedIn', false)
        props.setLoggedIn(false)
        window.localStorage.clear()
        navigate("/")
    }
    var month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const convertdate = (date) => {

        if (date !== undefined) {
            var d = date.split("-")[0];
            var m = date.split("-")[1];
            var y = date.split("-")[2];
            var time = d + " " + month[parseInt(m) - 1] + " " + y;

            return time;
        }


    }

    useEffect(() => {

        window.scrollTo(0, 0, {
            behavior: 'smooth'
        })


    }, [])

    useEffect(() => {
        document.title = "Order Details - Colorbot";// Set the title when component mounts
        return () => {
            document.title = "Order Details - Colorbot"; // Reset the title when component unmounts
        };
    }, []);

    useEffect(() => {
        if (window.localStorage.getItem("orderdetail") !== null) {
            var data = JSON.parse(window.localStorage.getItem("orderdetail"))
            data = [data]

            var totalsum = 0
            var subtotal = 0
            for (var i = 0; i < data[0].OrderDetail.length; i++) {
                totalsum += parseInt(data[0].OrderDetail[i].OrderTotal)
                subtotal += parseInt(data[0].OrderDetail[i].OrderSubTotal)
            }
            setOrderTotal(totalsum)
            setOrderSubTotal(subtotal)
            setOrderDetail(data)
        }

    }, [])
    const [showMore, setShowMore] = useState(false);
    const [showarr, setShowArr] = useState([0]);
    const [lgShow2, setLgShow2] = useState(false);

    const toggleShowMore = () => {
        setShowMore(!showMore);
        if (showMore) {
            setShowArr([0]);
        } else {
            setShowArr(orderdetail[0].OrderDetail.map((_, index) => index));
        }
    };

    const updateStatus = async () => {
        await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotCancelOrder`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${window.localStorage.getItem('token')}`
            },
            body: JSON.stringify({
                OrderId: orderdetail[0].OrderId,
                OrderStatus: "Cancelled",
                ShipRocket: orderdetail[0].ShipRocket,
            })

        }).then((res) => res.json()).then((response) => {


            if (response.status === 200) {
                navigate("/Order")
                toast.success(response.message)

            } else {
                toast.error(response.message)
            }
        }).catch((err) => {
            console.log(err)
        })

    }
   
    const navigateToProduct = (path) => {
        navigate(path);
    }

    const searchInTitle = (type, title) => {
        if (!type || !title) return false;
        return title.toLowerCase().includes(type.toLowerCase());
      };
    return (
        <>
            <section className="signback mt-5 pt-3 pb-5">

                <Modal
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"

                    centered
                    show={lgShow1}

                    onHide={() => setLgShow1(false)}

                >
                    <Modal.Header closeButton style={{ borderBottom: "none", padding: "1rem 1rem 0rem 0rem" }}>

                    </Modal.Header>
                    <Modal.Body style={{ paddingTop: "0rem" }}>


                        <div className="box-profile-pop-profile">



                            <div className="logoutpop">
                                <img src="assets/Vector.svg" className="img-fluid" alt="exlam" />
                            </div>
                            <div className="logoutpop mt-2">
                                <p>Are you sure you want to logout?</p>
                            </div>
                            <div className="logoutpop button">
                                <button className="btn btncancellog" onClick={() => setLgShow1(false)}>
                                    Cancel
                                </button>
                                <button className="btn btnsubmitlog" onClick={() => {
                                    Logoutmain()
                                }}>Logout</button>
                            </div>







                        </div>


                    </Modal.Body>
                </Modal>
                <Modal
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"

                    centered
                    show={lgShow2}

                    onHide={() => setLgShow2(false)}

                >
                    <Modal.Header closeButton style={{ borderBottom: "none", padding: "1rem 1rem 0rem 0rem" }}>

                    </Modal.Header>
                    <Modal.Body style={{ paddingTop: "0rem" }}>


                        <div className="box-profile-pop-profile">



                            <div className="logoutpop">
                                <img src="assets/Vector.svg" className="img-fluid" alt="exlam" />
                            </div>
                            <div className="logoutpop mt-2">
                                <p>Are you sure you want to cancel the order?</p>
                            </div>

                            <div className="cancel-pop">
                                <div className="form-check mt-2">
                                    <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                    <label className="form-check-label labeltitle" htmlFor="flexRadioDefault1">
                                        Placed order by mistake
                                    </label>
                                </div>
                                <div className="form-check mt-2">
                                    <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" />
                                    <label className="form-check-label labeltitle" htmlFor="flexRadioDefault2">
                                        Estimated delivery is too long
                                    </label>
                                </div>
                                <div className="form-check mt-2">
                                    <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault3" />
                                    <label className="form-check-label labeltitle" htmlFor="flexRadioDefault3">
                                        Changed my mind
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault4" />
                                    <label className="form-check-label labeltitle" htmlFor="flexRadioDefault4">
                                        Others
                                    </label>
                                </div>

                                <textarea className="form-control form-control-lg mt-3" rows="2" placeholder="Enter Your Message" ></textarea>

                            </div>

                            <div className="logoutpop button">
                                <button className="btn btncancellog" onClick={() => setLgShow2(false)}>
                                    No
                                </button>
                                <button className="btn btnsubmitlog" onClick={() => {
                                    updateStatus()
                                }}>Yes</button>
                            </div>







                        </div>


                    </Modal.Body>
                </Modal>
              
                <div className="container">

                    <div className="row justify-content-center mt-5">
                        <div className="col-lg-3 profilecolwidth mt-3">
                            <div className="profile_left">

                                <NavLink to="/Order" className="nodecoration">  <div className="tab_left tab-leftactive">
                                    <img src="https://colorbots3.s3.ap-south-1.amazonaws.com/myorder_left.svg" className="img-fluid" alt="order" />&nbsp;&nbsp;&nbsp; My Orders
                                </div></NavLink>
                                <NavLink to="/profile" className="nodecoration"> <div className="tab_left ">
                                    <img src="https://colorbots3.s3.ap-south-1.amazonaws.com/profile_left.svg" className="img-fluid" alt="profile" />&nbsp;&nbsp;&nbsp;&nbsp; Profile
                                </div></NavLink>
                                <div className="tab_left" onClick={() => {
                                    Logout()
                                }}>
                                    <img src="https://colorbots3.s3.ap-south-1.amazonaws.com/logout_left.svg" className="img-fluid" alt="logout" />&nbsp;&nbsp;&nbsp;&nbsp; Logout
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-9 mt-3">

                            <div className="background-boxx">
                                {orderdetail.length > 0 && orderdetail.map((item, index) => {
                                    let quantity = 0
                                    item.OrderDetail.map((item, index) => {
                                        quantity += parseInt(item.OrderQuantity)
                                    })
                                    let warranty = false
                                    item.OrderDetail.map((item, index) => {
                                        if (item.OrderExtendedWarranty) {
                                            warranty = true
                                        }
                                    })
                                    let warrantyprice = 0
                                    item.OrderDetail.map((item, index) => {
                                        if (item.OrderExtendedWarranty) {
                                            warrantyprice += 499 * parseInt(item.OrderQuantity)
                                        }
                                    })
                                    return (
                                        <div className="row" key={index}>
                                            <div className="col-md-12">
                                                <div className="order-id2">
                                                    <span>Order Id: <b>{item.OrderId}</b></span>
                                                </div>

                                                {item.OrderDetail.length > 0 && item.OrderDetail.map((mainitem, mainindex) => {
                                                    const isVisible = showarr.includes(mainindex);
                                                    return (

                                                        <div className={isVisible ? "all-side-box" : "all-side-box hidden"} key={mainindex}>
                                                            <div className="left-portition">

                                                                <div className="order-name">
                                                                    <span>{mainitem.OrderName}</span>
                                                                </div>
                                                                <div className="order-quantity">
                                                                    <span>Qty: {mainitem.OrderQuantity}</span>
                                                                </div>
                                                                <div className="order-color">
                                                                    <span>{searchInTitle("led",mainitem.OrderName)?"Pack Of":"Color"}: {mainitem.OrderColor}</span>
                                                                </div>
                                                                <div className="order-color">
                                                                    <span>{searchInTitle("led",mainitem.OrderName)?"Power":searchInTitle("geyser",mainitem.OrderName)?"Geyser":"Sweep Size"}: {mainitem.OrderSize}</span>
                                                                </div>

                                                            </div>

                                                            <div className="right-portition">
                                                                <div className="order-image">
                                                                    <img src={mainitem.OrderImage} alt="" style={{
                                                                        cursor: "pointer"
                                                                    }} onClick={() => {
                                                                        navigateToProduct(mainitem.ProductPath)
                                                                    }} />

                                                                </div>
                                                                <div className="order-price">
                                                                    <span>Rs. {mainitem.OrderSubTotal}</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    );
                                                })}
                                                {orderdetail[0].OrderDetail.length > 1 ? <div className="text-center orderallbutton" onClick={toggleShowMore}>
                                                    {showMore ? "View Less" : "View All"} &nbsp; &nbsp;
                                                    <img src="https://colorbots3.s3.ap-south-1.amazonaws.com/downarrowbuy.svg" className={showMore ? "img-fluid rotate" : "img-fluid"} alt="icon" />
                                                </div> : ""}


                                                <hr />

                                            </div>
                                            <br />
                                            {item.OrderStatus !== "Cancelled"&& item.OrderStatus !== "Pending" ? <div className="col-md-12 mt-4">
                                                <div className="mid-side-box">
                                                    <div className="ordered-confirmed ">
                                                        <span>Confirmed</span>
                                                        <p>{convertdate(item.OrderDate)}</p>
                                                    </div>
                                                    <div className="ordered-shipped">
                                                        <span>Shipped</span>
                                                        <p>{convertdate(item.OrdershippedDate)}</p>
                                                    </div>
                                                    <div className="ordered-shipped">
                                                        <span>Picked up</span>
                                                        <p>{convertdate(item.OrderPickedDate)}</p>
                                                    </div>
                                                    {item.OrderStatus === "RTO" ? <div className="ordered-delivered ">
                                                        <span>Denied</span>
                                                        <p>{convertdate(item.OrderRTODate)}</p>
                                                    </div> :
                                                        <div className="ordered-delivered ">
                                                            <span>Delivered</span>
                                                            <p>{convertdate(item.OrderDeliveredDate)}</p>
                                                        </div>}
                                                </div>
                                            </div> : ""}
                                            {item.OrderStatus !== "Cancelled" && item.OrderStatus !== "Pending" ? <div className="col-md-12">
                                                {item.OrderStatus === "Order Confirmed" ? <>
                                                    <div className="griddetail">
                                                        <div className={"order-tracking completed flexcenter"}>

                                                            <span className="is-complete"></span>
                                                        </div>
                                                        <div className={"order-tracking  flexcenter"}>

                                                            <span className="is-complete"></span>
                                                        </div>
                                                        <div className={"order-tracking  flexcenter"}>

                                                            <span className="is-complete"></span>
                                                        </div>
                                                        <div className={"order-tracking  flexcenter"}>

                                                            <span className="is-complete"></span>
                                                        </div>
                                                    </div></> : ""}
                                                {item.OrderStatus === "Shipped" ? <>
                                                    <div className="griddetail">
                                                        <div className={"order-tracking completed flexcenter"}>

                                                            <span className="is-complete"></span>
                                                        </div>
                                                        <div className={"order-tracking completed  flexcenter"}>

                                                            <span className="is-complete"></span>
                                                        </div>
                                                        <div className={"order-tracking  flexcenter"}>

                                                            <span className="is-complete"></span>
                                                        </div>
                                                        <div className={"order-tracking  flexcenter"}>

                                                            <span className="is-complete"></span>
                                                        </div>
                                                     </div></> : ""}
                                                {item.OrderStatus === "IN TRANSIT" ? <>
                                                    <div className="griddetail">
                                                        <div className={"order-tracking completed flexcenter"}>

                                                            <span className="is-complete"></span>
                                                        </div>
                                                        <div className={"order-tracking completed flexcenter"}>

                                                            <span className="is-complete"></span>
                                                        </div>
                                                        <div className={"order-tracking completed flexcenter"}>

                                                            <span className="is-complete"></span>
                                                        </div>
                                                        <div className={"order-tracking  flexcenter"}>

                                                            <span className="is-complete"></span>
                                                        </div>
                                                    </div></> : ""}
                                                {item.OrderStatus === "Delivered" ? <>
                                                    <div className="griddetail">
                                                        <div className={"order-tracking completed flexcenter"}>

                                                            <span className="is-complete"></span>
                                                        </div>
                                                        <div className={"order-tracking completed  flexcenter"}>

                                                            <span className="is-complete"></span>
                                                        </div>
                                                        <div className={"order-tracking completed  flexcenter"}>

                                                            <span className="is-complete"></span>
                                                        </div>
                                                        <div className={"order-tracking completed flexcenter"}>

                                                            <span className="is-complete"></span>
                                                        </div>
                                                    </div></> : ""}
                                                {item.OrderStatus === "RTO" ? <>
                                                    <div className="griddetail">
                                                        <div className={"order-tracking completed flexcenter"}>

                                                            <span className="is-complete"></span>
                                                        </div>
                                                        <div className={"order-tracking completed  flexcenter"}>

                                                            <span className="is-complete"></span>
                                                        </div>
                                                        <div className={"order-tracking completed  flexcenter"}>

                                                            <span className="is-complete"></span>
                                                        </div>
                                                        <div className={"order-tracking rto flexcenter"}>

                                                            <span className="is-rto"></span>
                                                        </div>
                                                    </div></> : ""}


                                            </div> : item.OrderStatus === "Pending"? <div className="col-md-12 pt-3">
                                                <p className="text-warning text-center">Your Order is Pending</p>
                                            </div>:<div className="col-md-12 pt-3">
                                                <p className="text-danger text-center">Order Cancelled</p>
                                            </div>}
                                            
                                            <br />
                                            <div className="col-md-12">
                                                {item.OrderStatus === "Delivered" ?
                                                   <a style={{textDecoration:"none",color:"black",fontWeight:"500"}} href={orderdetail[0]?.InvoiceLink} download={orderdetail[0]?.InvoiceLink} target="_blank"><div className="thirrd-box" style={{ cursor: "pointer" }} >
                                                        <div className="first-imagee">
                                                            <img src="https://colorbots3.s3.ap-south-1.amazonaws.com/file.svg" alt="Invoice file icon" loading="lazy" />
                                                            <span>Invoice Download</span>
                                                        </div>

                                                        <div className="second-image">
                                                            <img src="https://colorbots3.s3.ap-south-1.amazonaws.com/download.svg" alt="Download icon" loading="lazy" />
                                                        </div>
                                                    </div></a>  : <div className="thirrd-box" >
                                                        <div className="first-imagee">
                                                            <img src="https://colorbots3.s3.ap-south-1.amazonaws.com/file.svg" alt="Invoice file icon" loading="lazy" />
                                                            <span>Invoice Download</span>
                                                        </div>

                                                        <div className="second-image">
                                                            <img src="https://colorbots3.s3.ap-south-1.amazonaws.com/download.svg" alt="Download icon" loading="lazy" />
                                                        </div>
                                                    </div>}
                                            </div>

                                            <div className="col-md-6">
                                                <div className="shipping-details">
                                                    <span>Shipping Details</span>

                                                </div>
                                                <div className="shipping-detail-box">
                                                    <div className="fulll-name">
                                                        <span>{item.OrderAddress?.[0]?.FirstName} {item.OrderAddress?.[0]?.LastName}</span>
                                                    </div>
                                                    <div className="shipping-address mt-2">
                                                        <span>{item.OrderAddress?.[0]?.Address} {item.OrderAddress?.[0]?.Address1}<br />
                                                            {item.OrderAddress?.[0]?.City},<br />
                                                            {item.OrderAddress?.[0]?.State}, {item.OrderAddress?.[0]?.Pincode}</span>
                                                    </div>
                                                    <div className="shipping-phone-no mt-2">
                                                        <span>{item.OrderAddress?.[0]?.Phone.slice(3)}</span>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="price-details">
                                                    <span>Price Details</span>

                                                </div>
                                                <div className="price-details-box">
                                                    <div className="list-of-desc">
                                                        <div>
                                                            <span>Listing Price</span>
                                                        </div>
                                                        <div className="mt-2">
                                                            <span>Selling Price</span>
                                                        </div>
                                                        <div className="mt-2">
                                                            <span>Total Saving</span>
                                                        </div>
                                                        <div className="mt-2">
                                                            <span>Shipping</span>
                                                        </div>
                                                        {warranty ? <div className="mt-2">
                                                            <span>Extended Warranty</span>
                                                        </div> : ""}
                                                        {parseInt(item.OrderCoupanPrice) > 0 ? <div className="mt-2">
                                                            <span>Coupon</span>
                                                        </div> : ""}
                                                        <div className="mt-2">
                                                            <span>Total Amount ({item.OrderPaymentType}) </span>
                                                        </div>
                                                    </div>
                                                    <div className="list-of-price text-end">
                                                        <div>
                                                            <span>Rs. {ordertotal}</span>
                                                        </div>
                                                        <div className="mt-2" >
                                                            <span>Rs. {ordersubtotal}</span>
                                                        </div>
                                                        <div className="mt-2">
                                                            <span>Rs. {parseInt(ordertotal) - parseInt(ordersubtotal) - parseInt(item.OrderCoupanPrice)}</span>
                                                        </div>
                                                        <div className="freee mt-2">
                                                            <strong>Free</strong> <span>Rs. {100 * quantity}</span>
                                                        </div>
                                                        {warranty ? <div className="freee mt-2">
                                                            <strong>Free</strong> <span>Rs. {warrantyprice}</span>
                                                        </div> : ""}
                                                        {parseInt(item.OrderCoupanPrice) > 0 ? <div className="mt-2">
                                                            <span>Rs. {item.OrderCoupanPrice}</span>
                                                        </div> : ""}
                                                        <div className="mt-2">
                                                            <span>Rs. {ordersubtotal - parseInt(item.OrderCoupanPrice)}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <br />


                                            {moment().diff(moment(item.OrderDate, 'DD-MM-YYYY HH:mm:ss'), 'minutes') < 240 && (item.OrderStatus === "Order Confirmed" || item.OrderStatus === "Pending") ?

                                                <div className="col-md-12 d-flex justify-content-between ">

                                                    <div className="d-flex justify-content-end"><button className="btn btn-cancel" onClick={() => {
                                                        setLgShow2(true)
                                                    }}>Cancel Order</button>
                                                        <p className="btn-txt">
                                                            Note: Once the order ships, you will not be able to cancel the order.
                                                        </p>
                                                    </div>
                                                    {item.OrderStatus !== "Delivered" && item.OrderStatus !== "Cancelled" ? <a href="https://www.shiprocket.in/shipment-tracking/" target="_blank" className="cncle-dis"> <button className="btn btn-cancel" style={{
                                                        border: " 0.8px solid #242933",
                                                        color: "#242933"
                                                    }}>Track Order</button></a> : <div className="d-flex justify-content-end cncle-dis"><button className="btn btn-cancel" disabled={item.OrderStatus === "Delivered" || item.OrderStatus === "Cancelled"} style={{
                                                        border: " 0.8px solid #242933",
                                                        color: "#242933"
                                                    }}>Track Order</button></div>}
                                                </div>
                                                : <div className="col-md-12 d-flex justify-content-between">

                                                    <div className="d-flex justify-content-end cncle-dis">
                                                        <button className="btn btn-cancel" disabled onClick={() => {
                                                            setLgShow2(true)
                                                        }}>Cancel Order</button>
                                                        <p className="btn-txt">
                                                            Note: Once the order ships, you will not be able to cancel the order.
                                                        </p></div>
                                                    {item.OrderStatus !== "Delivered" && item.OrderStatus !== "Cancelled" ? <a href="https://www.shiprocket.in/shipment-tracking/" target="_blank" className="cncle-dis"> <button className="btn btn-cancel" style={{
                                                        border: " 0.8px solid #242933",
                                                        color: "#242933"
                                                    }}>Track Order</button></a> : <div className="d-flex justify-content-end cncle-dis"><button className="btn btn-cancel" disabled={item.OrderStatus === "Delivered" || item.OrderStatus === "Cancelled"} >Track Order</button></div>}
                                                </div>}





                                        </div>
                                    )
                                })}




                            </div>

                        </div>


                    </div>
                </div>
            </section>
        </>
    );
}
export default OrderDetail;